__turbopack_context__.v({
  "className": "carmatitlefont_a200172c-module__KE4F2a__className",
  "variable": "carmatitlefont_a200172c-module__KE4F2a__variable",
});
